var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('header', {
    staticClass: "py-2 border-bottom border-gray-9 mb-2",
    class: {
      'd-flex align-items-center justify-content-between': _vm.btn
    }
  }, [_c('h2', {
    staticClass: "text-18 text-md-20 fw-600 text-gray-2"
  }, [_vm._v(_vm._s(_vm.title))]), _vm.btn ? _c('div', {
    staticClass: "ml-auto"
  }, [_c('b-btn', _vm._b({
    attrs: {
      "variant": "platform-light py-1 px-3 text-12 fw-600"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('btn-click', $event);
      }
    }
  }, 'b-btn', _vm.btn.props, false), [_vm._v(" " + _vm._s(_vm.btn.text) + " ")])], 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }